import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Menu from "src/components/panel/meal/menu/Menu";

const MenuView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("meal_food_menu_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("meal_food_menu_list_title")}
          subtitle={t("meal_food_menu_list_subtitle")}
        />
        <Menu />
      </Sidebar>
    </>
  );
};

export default MenuView;
